const STORAGE_KEY = "treydora_pending_library_purchase";
const MAX_AGE_MS = 45 * 60 * 1000;

/**
 * Persist library Stripe checkout intent across login/register (sessionStorage).
 * Only `authGate: "email"` entries are auto-resumed after sign-in (never wallet-only login).
 * @param {{ editionId: string, assetSlug?: string, assetId?: string, returnPath?: string, purchaseKind?: "digital" | "nft_mint", quantity?: number, tierKey?: string, authGate?: "email" }} data
 */
export function setPendingLibraryPurchase(data) {
  try {
    const editionId = String(data?.editionId || "").trim();
    if (!editionId) return;
    const purchaseKind = data?.purchaseKind === "nft_mint" ? "nft_mint" : "digital";
    const rawQty = data?.quantity;
    const qn = parseInt(String(rawQty != null ? rawQty : "1"), 10);
    const quantity = Number.isInteger(qn) && qn >= 1 ? qn : 1;
    const payload = {
      editionId,
      assetSlug: String(data?.assetSlug || "").trim(),
      assetId: String(data?.assetId || "").trim(),
      returnPath: String(data?.returnPath || "").trim() || `${window.location.pathname}${window.location.search}`,
      purchaseKind,
      tierKey: String(data?.tierKey || "").trim(),
      quantity: purchaseKind === "nft_mint" ? quantity : undefined,
      authGate: data?.authGate === "email" ? "email" : undefined,
      ts: Date.now(),
    };
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  } catch {
    /* noop */
  }
}

/** @returns {{ editionId: string, assetSlug?: string, assetId?: string, returnPath?: string, purchaseKind?: string, tierKey?: string, quantity?: number, ts: number } | null} */
export function getPendingLibraryPurchase() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const o = JSON.parse(raw);
    if (!o || typeof o !== "object" || !o.editionId) return null;
    if (typeof o.ts !== "number" || Date.now() - o.ts > MAX_AGE_MS) {
      sessionStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return o;
  } catch {
    return null;
  }
}

export function clearPendingLibraryPurchase() {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    /* noop */
  }
}
